// extracted by mini-css-extract-plugin
export var copyright = "style-module--copyright--21ba2";
export var footer = "style-module--footer--d5b7f";
export var footerBottom = "style-module--footerBottom--7a8a8";
export var footerLeft = "style-module--footerLeft--85bbb";
export var footerRight = "style-module--footerRight--f0d0f";
export var footerTop = "style-module--footerTop--d0274";
export var footer_logo = "style-module--footer_logo--4f629";
export var list = "style-module--list--859ae";
export var map = "style-module--map--860d9";
export var nav_item = "style-module--nav_item--38ea7";
export var sample_btn = "style-module--sample_btn--77de2";
export var sns_list = "style-module--sns_list--244b5";